export default __webpack_public_path__ + "static/media/e_wdt_c_0_1_2.44997bc5.mp3";